

































































import Vue from "vue";
import { ResetPasswordClient } from "@/api/open-api";
export default Vue.extend({
  name: "Reset",
  data() {
    return {
      email: "",
      reset: new ResetPasswordClient()
    };
  },
  methods: {
    async onsubmit() {
      this.$q.loading.show();

      const getToken = await this.reset.placeToken(this.email);
      if (getToken.error == null) {
        this.$q.loading.hide();
        this.$q.notify({
          progress: true,
          message: "richiesta reset avvenuta con successo controllare nella casella postale",
          type: "positive"
        });
      } else {
        this.$q.loading.hide();
        this.$q.notify({
          progress: true,
          message: getToken.error?.toString(),
          type: "negative"
        });
      }
    }
  }
});
